window.Parsley.addValidator("unicity", {
	requirementType: "string",
	validateString: function(value, requirement, parsleyInstance) {
		var $otherElements = $(requirement);
		var duplicateFound = false;

		$otherElements.each(function(){
			duplicateFound = duplicateFound || (parsleyInstance.$element[0] !== this && this.value === value);
		});

		return !duplicateFound;
	},
	priority: 33
});
;

export {};